export const SUBMITTED = 'Submitted';
export const PROCESSING = 'Processing';
export const AWAITING_CUSTOMER_REVIEW = 'Awaiting Customer Review';
export const VERIFIED = 'Verified';
export const ACTIVE = 'Active';
export const CLOSED = 'Closed';
